import { useEffect, useState } from 'react';
import { ICloudProvider } from './types';
import { doRequest, Methods } from 'Request';

interface IUseCloudProvidersFetch {
  onSuccess(data: ICloudProvider[]): void;
  customerId?: string;
}

export const useCloudProvidersFetch = ({ onSuccess, customerId }: IUseCloudProvidersFetch) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    if (!loading && !error) {
      setLoading(true);
      (async () => {
        try {
          const { data } = await getCloudProviders(customerId);
          onSuccess(data);
        } catch (e) {
          setError(true);
        } finally {
          setLoading(false);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { error, loading };
};


export const getCloudProviders = (customerId?: string) => {
  return doRequest({
    method: Methods.GET,
    path: `/cloud-connect-providers?` + (customerId ? `customer_id=${customerId}` : ''),
  });
};